"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommonBankAccountValidator_1 = __importDefault(require("../CommonBankAccountValidator"));
var ItauCheckNumberCalculator_1 = __importDefault(require("./CheckNumber/ItauCheckNumberCalculator"));
var ItauValidator = /** @class */ (function (_super) {
    __extends(ItauValidator, _super);
    function ItauValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItauValidator.prototype.agencyCheckNumberIsValid = function (agencyCheckNumber) {
        return agencyCheckNumber === undefined || agencyCheckNumber === "" || agencyCheckNumber === "0";
    };
    ItauValidator.prototype.accountNumberIsValid = function (accountNumber) {
        return accountNumber.length === this.accountNumberLength() && _super.prototype.accountNumberIsValid.call(this, accountNumber);
    };
    ItauValidator.prototype.accountCheckNumberMatch = function (bankAccount) {
        var checkNumberCalculated = ItauCheckNumberCalculator_1.default.calculate(bankAccount.agencyNumber, bankAccount.accountNumber);
        return checkNumberCalculated === bankAccount.accountCheckNumber;
    };
    ItauValidator.prototype.accountNumberLength = function () {
        return 5;
    };
    return ItauValidator;
}(CommonBankAccountValidator_1.default));
exports.default = ItauValidator;
//# sourceMappingURL=ItauValidator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/br-bank-account-validator/dist/Validators/ItauValidator.js
// module id = 920
// module chunks = 2